import { Link } from "@quintype/components";
import React from "react";
import Facebook from "../../atoms/social-media-icons/Facebook";
import Instagram from "../../atoms/social-media-icons/Instagram";
import Telegram from "../../atoms/social-media-icons/Telegram";
import Twitter from "../../atoms/social-media-icons/Twitter";
import Whatsapp from "../../atoms/social-media-icons/Whatsapp";
import Youtube from "../../atoms/social-media-icons/Youtube";

import "./follow-us-social-media.m.css";
const SOCIAL_MEDIA_CONTENT = [
  {
    link: "https://www.whatsapp.com/channel/0029Va4ifN6AYlULZASc7V3S",
    icon: <Whatsapp width="14" height="14" color="black" />
  },
  { link: "https://www.facebook.com/deccanherald/", icon: <Facebook width="14" height="14" color="black" /> },
  { link: "https://twitter.com/deccanherald", icon: <Twitter width="14" height="14" color="black" /> },
  { link: "https://www.instagram.com/deccanherald/", icon: <Instagram width="14" height="14" color="black" /> },
  {
    link: "https://www.youtube.com/channel/UCHDXXHPrz-1GVbK_qk82hBQ",
    icon: <Youtube width="14" height="14" color="black" />
  },
  { link: "https://t.me/DeccanHeraldNews", icon: <Telegram width="14" height="14" color="black" /> }
];

function FollowUsSocialMedia() {
  return (
    <div styleName="wrapper">
      <span>
        <h2>Follow Us</h2>
      </span>
      <div styleName="subscribe-social-icons">
        {SOCIAL_MEDIA_CONTENT?.map((item, index) => (
          <Link styleName="icon-wrapper" href={item.link} key={index} target="_blank">
            {item.icon}
          </Link>
        ))}
      </div>
    </div>
  );
}

export default FollowUsSocialMedia;
